export const DEFAULT_LANGUAGE = 'fr';
export const AVAILABLE_LANGUAGE = ['fr', 'en'];
